import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './demand_monitoring.routes';

export default angular.module('leptonApp.demandMonitoring', [uiRouter])
    .config(routing)
    .component('demandMonitoring', {
        template: require('./demand_monitoring.html')
    })
    .name;



// WEBPACK FOOTER //
// ./public/dev/app/demand/monitoring/demand_monitoring.component.js